<template>
	<div>
		<v-dialog v-model="dialog_exportType" no-click-animation scrollable persistent content-class="full-height" transition="dialog-bottom-transition">
			<v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader>Select Export Type</v-subheader>
	        	</v-card-title>
	        	<v-divider></v-divider>
		        <v-card-text full-height nopadding>

			        <v-list nopadding>
			        	<v-list-tile v-for="(item, index) in exportTypes" :key="index" @click="updateExportType(item)">

				            <v-list-tile-content>
				              <v-list-tile-title>{{item}}</v-list-tile-title>
				            </v-list-tile-content>

				            <v-list-tile-action>
						        <v-icon v-if="item == selectedExportType">radio_button_checked</v-icon>
						        <v-icon v-else>radio_button_unchecked</v-icon>
				            </v-list-tile-action>

			        	</v-list-tile>
			        </v-list>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		        </v-card-actions>
		    </v-card>

	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['updateExportType', 'selectedExportType'],
		data(){
			return{
				exportTypes: ["Export under bond/LUT", "Export with IGST", "SEZ without IGST Payment" , "SEZ with IGST Payment"],
				dialog_exportType:false,
			}
		},
		methods:{
			openDialogWeb: function () {
				this.dialog_exportType = true;
			},
			closeDialogWeb: function () {
				this.dialog_exportType = false;
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/sale/dialogs/dialog_export_types.vue